
(function() {
  var result = { translations: { "it": { "foundations-components": { "ActionsMenu": { "defaultAriaLabel": "Azioni" }, "tag": { "remove": "Rimuovi tag" }, "Select": { "noResults": "Nessun risultato trovato", "searchPlaceholder": "Cerca...", "clearSelections": "Cancella selezione" }, "ErrorMessage": { "error": { "title": "Non tutto \xE8 perduto." }, "notFound": { "title": "Non tutti gli erranti son perduti." }, "badRequest": { "title": "Si \xE8 verificato un problema durante il caricamento della pagina." }, "expired": { "title": "Spiacenti." }, "sessionId": { "prefix": "ID sessione: " } }, "ProgressSteps": { "completedStep": "Passaggio completato", "incompleteStep": "Passaggio non completato" }, "Paginator": { "label": "Impaginazione", "pageNumber": { "currentIndicator": "Ti trovi alla pagina", "description": "Pagina" }, "firstPage": { "label": "Prima", "description": "Prima pagina" }, "previousPage": { "label": "Indietro", "description": "Pagina precedente" }, "nextPage": { "label": "Avanti", "description": "Pagina successiva" }, "lastPage": { "label": "Ultima", "description": "Ultima pagina" } }, "Datagrid": { "noData": { "Title": "Nessun dato disponibile", "Description": "Non sono disponibili dati da mostrare." }, "noResults": { "Title": "Nessun risultato trovato", "Description": "Prova a cambiare la ricerca e i filtri per trovare ci\xF2 che stai cercando.", "ClearActionLabel": "Cancella ricerca e filtri" }, "toolbar": { "selectedRows": { "one": "{{count}} riga selezionata", "other": "{{count}} righe selezionate", "clearSelection": "Cancella selezione", "selectAll": "Seleziona tutte le {{totalRows}} righe" }, "search": { "placeholder": "Cerca", "label": "Cerca", "clearSearch": "Cancella ricerca" } }, "pagination": { "visibleRows": "{{visibleRows}} di {{totalRows}} risultati", "itemsPerPage": "Elementi per pagina", "countPerPage": { "one": "{{count}} per pagina", "other": "{{count}} per pagina", "many": "{{count}} per pagina" } }, "SkeletonGrid": { "loading": "Caricamento" }, "DataGridColumnManagementPanel": { "description": "Scegli quali propriet\xE0 mostrare come colonne. Quindi, sposta le propriet\xE0 su e gi\xF9, o trascinale per cambiare l'ordine di visualizzazione.", "removeAllColumns": "Rimuovi tutte le colonne", "update": "Aggiorna", "cancel": "Annulla", "edit": "Modifica colonne" } } }, "ui": { "UIAbstractPageSection": { "page": "Sezione pagina" }, "UICarousel": { "current": "Oggetto {{currentStepDisplayNumber}}di {{totalSteps}}", "prev": "Precedente", "next": "Avanti", "tip": "usa i tasti Freccia per vedere gli altri articoli" }, "UIColorSwatch": { "label": "Selezione colore {{value}}", "noColorLabel": "Scelta colore, nessun colore selezionato." }, "UIButtonCollapser": { "dropdownLabel": "Azioni" }, "UIErrorMessage": { "error": { "title": "Non tutto \xE8 perduto." }, "notFound": { "title": "Non tutti gli erranti son perduti." }, "badRequest": { "title": "Si \xE8 verificato un problema durante il caricamento della pagina." }, "expired": { "title": "Siamo spiacenti." } }, "UIPanelNavigator": { "backButton": "Torna alla schermata precedente" }, "UILoadingSpinner": { "busyText": "Caricamento", "completedText": "Caricato" }, "UISideNav": { "navigationLandmark": "Secondario" }, "UISortTH": { "ascendingSort": "Ordine crescente. Premi per impostare l'ordine decrescente.", "descendingSort": "Ordine decrescente. Premi per impostare l'ordine crescente.", "pressToSort": "Premi per ordinare." }, "autosizedTextInput": { "charactersRemaining": "{{value}} caratteri rimasti" }, "time": { "today": "Oggi alle {{time}}", "yesterday": "Ieri alle {{time}}", "datetime": "{{date}} alle {{time}}" }, "progress": { "percentComplete": "Percentuale completamento: {{percent}}" }, "datePicker": { "dateSelected": "Il giorno {{date}} \xE8 selezionato.", "noDateSelected": "Nessuna data selezionata.", "dateBelowMin": "Scegli una data pi\xF9 recente", "dateAboveMax": "Scegli una data meno recente", "invalidDate": "Data non valida", "today": "Oggi", "clear": "Cancella", "placeholder": { "month": "MM", "day": "GG", "year": "AAAA" }, "nextMonth": "Il mese prossimo", "prevMonth": "Mese precedente" }, "dateRange": { "startDate": "Data di inizio", "endDate": "Data fine", "endDateBeforeStartDate": "La data di fine deve essere successiva alla data di inizio.", "startDateAfterEndDate": "La data di inizio deve essere precedente alla data di fine.", "to": "a" }, "timePicker": { "placeholder": { "hour": "HH", "minute": "MM" } }, "SelectResultList": { "andMore": "\u2026e ancora {{count}}.", "loadMore": "Carica altro" } }, "salesUI": { "UIAvatarAdd": { "ariaLabel": "Aggiungi" }, "UIAvatarHoverlay": { "text": "Cambia foto" }, "UIChangeArrow": { "decrease": "Riduci di ", "increase": "Aumenta di " }, "UICopyInput": { "label": "Copia", "title": "Copia negli appunti", "tooltipCopied": "Copiato" }, "UIConfirm": { "defaultConfirm": "S\xEC", "defaultReject": "No" }, "UICloseButton": { "label": "Chiudi" }, "UIDateRangePicker": { "rangeType": { "ALL": "Sempre", "THIS_DAY": "Oggi", "LAST_DAY": "Ieri", "THIS_WEEK": "Questa settimana", "LAST_WEEK": "Settimana scorsa", "THIS_MONTH": "Questo mese", "LAST_MONTH": "Il mese scorso", "LAST_THIRTY_DAYS": "Ultimi 30 giorni", "LAST_THREE_MONTHS": "Ultimi 3 mesi", "THIS_QUARTER": "Questo trimestre", "LAST_QUARTER": "L'ultimo trimestre", "THIS_YEAR": "Quest'anno", "LAST_YEAR": "Lo scorso anno", "CUSTOM": "Periodo di tempo personalizzato" } }, "UIDropdownSelect": { "placeholder": "Nessun valore selezionato" }, "UIEditableControls": { "cancel": "Annulla", "save": "Salva" }, "UIExpandableText": { "collapseButtonText": "Visualizza di meno", "expandButtonText": "Visualizza di pi\xF9" }, "UIFileInput": { "defaultChangeLabel": "Cambia file", "defaultSelectLabel": "Scegli file" }, "UIIconRating": { "ariaValueText": "{{value}} su {{maxValue}}" }, "UILink": { "externalTitle": "Apertura link in una nuova finestra" }, "UILoading": { "title": "Caricamento..." }, "UILockBadge": { "title": "La funzione \xE8 bloccata" }, "UIPaginator": { "label": "Impaginazione", "pageNumber": { "currentIndicator": "Ti trovi alla pagina ", "description": "Pagina " }, "firstPage": { "label": "Prima", "description": "Prima pagina" }, "previousPage": { "label": "Indietro", "description": "Pagina precedente" }, "nextPage": { "label": "Avanti", "description": "Pagina successiva" }, "lastPage": { "label": "Ultima", "description": "Ultima pagina" } }, "UIPreviousButton": { "label": "Precedente" }, "UINextButton": { "label": "Avanti" }, "UINumberRating": { "lowRangeLabel": "Per niente d'accordo", "highRangeLabel": "Pienamente d'accordo" }, "UISearchableSelectInput": { "placeholder": "Cerca" }, "UISearchInput": { "placeholder": "Cerca", "minimumSearchMessage": { "one": "Digita 1 altro carattere", "other": "Digita altri {{count}} caratteri", "many": "Digita {{count}} di altri caratteri" }, "clearButton": "Cancella input" }, "UISelect": { "allOptionsSelected": "Tutte le opzioni sono selezionate", "createOption": "Crea opzione \"{{label}}\"", "plusMore": "+ {{count}} ancora", "andMore": "\u2026e ancora {{count}}.", "loadMore": "Carica altro", "noResults": "Nessun risultato trovato", "placeholder": "Cerca", "typeToSearch": "Digita per avviare la ricerca" }, "UITable": { "selectableTableRow": { "toggleSelection": "Attiva/disattiva selezione della riga" } }, "UITabs": { "moreDropdownLabel": "Altro" }, "UITeaseNotification": { "optionsButtonTooltipText": "Mostra opzioni" }, "UITimePicker": { "placeholder": "Seleziona un'ora" }, "UIToggle": { "checkedLabel": "ON", "uncheckedLabel": "OFF" }, "UITypeahead": { "noMatchesFound": "Nessuna corrispondenza trovata", "noOptions": "Nessuno" }, "UIWizard": { "back": "Indietro", "cancel": "Annulla", "done": "Operazione completata", "next": "Avanti", "stepCount": "Fase {{stepNumber}} di {{stepCount}}" }, "XSSTooltip": { "explanation": "Il link \xE8 stato disabilitato per motivi di sicurezza." } } } } };
  result.translationsLoaded = {
  "foundations-components": {
    "it": "static-1.5772"
  }
};
  result.translationsAvailable = {
  "foundations-components": {
    "af": "static-1.5772",
    "ar-eg": "static-1.5772",
    "bg": "static-1.5772",
    "bn": "static-1.5772",
    "ca-es": "static-1.5772",
    "cs": "static-1.5772",
    "da": "static-1.5772",
    "de": "static-1.5772",
    "el": "static-1.5772",
    "en-gb": "static-1.5772",
    "en": "static-1.5772",
    "es-mx": "static-1.5772",
    "es": "static-1.5772",
    "et": "static-1.5772",
    "fi": "static-1.5772",
    "fr-ca": "static-1.5772",
    "fr": "static-1.5772",
    "he-il": "static-1.5772",
    "hi": "static-1.5772",
    "hr": "static-1.5772",
    "hu": "static-1.5772",
    "id": "static-1.5772",
    "it": "static-1.5772",
    "ja": "static-1.5772",
    "ko": "static-1.5772",
    "lt": "static-1.5772",
    "ms": "static-1.5772",
    "nl": "static-1.5772",
    "no": "static-1.5772",
    "pl": "static-1.5772",
    "pt-br": "static-1.5772",
    "pt-pt": "static-1.5772",
    "ro": "static-1.5772",
    "ru": "static-1.5772",
    "sk": "static-1.5772",
    "sl": "static-1.5772",
    "sv": "static-1.5772",
    "th": "static-1.5772",
    "tl": "static-1.5772",
    "tr": "static-1.5772",
    "uk": "static-1.5772",
    "vi": "static-1.5772",
    "zh-cn": "static-1.5772",
    "zh-hk": "static-1.5772",
    "zh-tw": "static-1.5772"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:foundations-components:it', {version: 'static-1.5772'}); }
})();



(function() {
  var result = { translations: { "it": { "placeholder": "segnaposto" } } };
  result.translationsLoaded = {
  "UIComponents": {
    "it": "static-3.7046"
  }
};
  result.translationsAvailable = {
  "UIComponents": {
    "af": "static-3.7046",
    "ar-eg": "static-3.7046",
    "bg": "static-3.7046",
    "bn": "static-3.7046",
    "ca-es": "static-3.7046",
    "cs": "static-3.7046",
    "da": "static-3.7046",
    "de": "static-3.7046",
    "el": "static-3.7046",
    "en-gb": "static-3.7046",
    "en": "static-3.7046",
    "es-mx": "static-3.7046",
    "es": "static-3.7046",
    "et": "static-3.7046",
    "fi": "static-3.7046",
    "fr-ca": "static-3.7046",
    "fr": "static-3.7046",
    "he-il": "static-3.7046",
    "hi": "static-3.7046",
    "hr": "static-3.7046",
    "hu": "static-3.7046",
    "id": "static-3.7046",
    "it": "static-3.7046",
    "ja": "static-3.7046",
    "ko": "static-3.7046",
    "lt": "static-3.7046",
    "ms": "static-3.7046",
    "nl": "static-3.7046",
    "no": "static-3.7046",
    "pl": "static-3.7046",
    "pt-br": "static-3.7046",
    "pt-pt": "static-3.7046",
    "ro": "static-3.7046",
    "ru": "static-3.7046",
    "sk": "static-3.7046",
    "sl": "static-3.7046",
    "sv": "static-3.7046",
    "th": "static-3.7046",
    "tl": "static-3.7046",
    "tr": "static-3.7046",
    "uk": "static-3.7046",
    "vi": "static-3.7046",
    "zh-cn": "static-3.7046",
    "zh-hk": "static-3.7046",
    "zh-tw": "static-3.7046"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:UIComponents:it', {version: 'static-3.7046'}); }
})();



(function() {
  var result = { translations: { "it": { "app": { "htmlTitle": "UI ink virali", "welcomeHome": "Ti diamo il benvenuto a casa, {{ firstName }}", "yourAppIsReady": "La tua app \xE8 pronta", "aSecondPage": "Una seconda pagina per conservare pi\xF9 contenuti", "fillPage_jsx": function (createElement, options, props) { return createElement( options, "wrapper", null, "Riempi questa pagina vuota con ", createElement( options, "Link", props.linkProps, "componenti" ), " su ", createElement( options, "code", null, props.filename ), "." ); }, "viralLinks": { "forms": { "linkCta": "<strong>Crea i tuoi form gratuiti</strong> per generare lead fdal tuo sito web." }, "liveChat": { "linkCta": "<strong>Aggiungi una chat in tempo reale.</strong> Entra in contatto con i visitatori. Gratis.", "ariaLabel": "Aggiungi una chat in tempo reale. Entra in contatto con i visitatori. Gratis." }, "liveChatIntermediate": { "linkCta": "<strong>[Int] Aggiungi una chat in tempo reale.</strong> Entra in contatto con i visitatori. Gratis.", "ariaLabel": "[Int] Aggiungi una chat in tempo reale. Entra in contatto con i visitatori. Gratis." }, "meetings": { "linkCta": "<strong>Crea la tua pagina di prenotazioni delle riunioni gratuita</strong> per pianificare le riunioni pi\xF9 velocemente." } } } } } };
  result.translationsLoaded = {
  "embedded-viral-link-ui": {
    "it": "static-1.4828"
  }
};
  result.translationsAvailable = {
  "embedded-viral-link-ui": {
    "af": "static-1.4828",
    "ar-eg": "static-1.4828",
    "bg": "static-1.4828",
    "bn": "static-1.4828",
    "ca-es": "static-1.4828",
    "cs": "static-1.4828",
    "da": "static-1.4828",
    "de": "static-1.4828",
    "el": "static-1.4828",
    "en-gb": "static-1.4828",
    "en": "static-1.4828",
    "es-mx": "static-1.4828",
    "es": "static-1.4828",
    "et": "static-1.4828",
    "fi": "static-1.4828",
    "fr-ca": "static-1.4828",
    "fr": "static-1.4828",
    "he-il": "static-1.4828",
    "hi": "static-1.4828",
    "hr": "static-1.4828",
    "hu": "static-1.4828",
    "id": "static-1.4828",
    "it": "static-1.4828",
    "ja": "static-1.4828",
    "ko": "static-1.4828",
    "lt": "static-1.4828",
    "ms": "static-1.4828",
    "nl": "static-1.4828",
    "no": "static-1.4828",
    "pl": "static-1.4828",
    "pt-br": "static-1.4828",
    "pt-pt": "static-1.4828",
    "ro": "static-1.4828",
    "ru": "static-1.4828",
    "sk": "static-1.4828",
    "sl": "static-1.4828",
    "sv": "static-1.4828",
    "th": "static-1.4828",
    "tl": "static-1.4828",
    "tr": "static-1.4828",
    "uk": "static-1.4828",
    "vi": "static-1.4828",
    "zh-cn": "static-1.4828",
    "zh-hk": "static-1.4828",
    "zh-tw": "static-1.4828"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:embedded-viral-link-ui:it', {version: 'static-1.4828'}); }
})();


